import React, { useState, useEffect } from 'react';

const BJSpinner = ({ isLoading, text, color }) => {
  const [isExiting, setIsExiting] = useState(false);    
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setIsVisible(true);
      setIsExiting(false);
    } else {
      if (isVisible) {
        // Start exit animation
        setIsExiting(true);
        // Remove component after animation completes
        const timer = setTimeout(() => {
          setIsVisible(false);
        }, 500); // Match this with your exit animation duration
        return () => clearTimeout(timer);
      }
    }
  }, [isLoading]);

  if (!isVisible) return null;

  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(255, 255, 255, 0.8)',
      backdropFilter: 'blur(100px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
      flexDirection: 'column',
      opacity: isExiting ? 0 : 1,
      transition: 'opacity 0.5s ease-out',
    },
    spinner: {
      width: '60px',
      height: '60px',
      border: `4px solid #f3f3f3`,
      borderRadius: '50%',
      borderTop: `4px solid ${color || '#2B7CD3'}`,
      animation: 'spin 1s linear infinite',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
    },
    text: {
      marginTop: '20px',
      fontFamily: "'Segoe UI', sans-serif",
      fontWeight: 600,
      color: color || '#2B7CD3',
      animation: 'pulse 1.5s ease-in-out infinite',
      letterSpacing: '1px',
    },
    successAnimation: {
      width: '100px',
      height: '100px',
      opacity: isExiting ? 1 : 0,
      transform: isExiting ? 'scale(1)' : 'scale(0.5)',
      transition: 'all 0.5s ease-out',
      position: 'absolute',
    }
  };

  return (
    <div style={styles.overlay}>
      {/* CSS Animations */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes pulse {
            0% { opacity: 0.6; }
            50% { opacity: 1; }
            100% { opacity: 0.6; }
          }
          @keyframes scaleIn {
            0% { transform: scale(0); opacity: 0; }
            80% { transform: scale(1.1); }
            100% { transform: scale(1); opacity: 1; }
          }
          .checkmark {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            display: block;
            stroke-width: 5;
            stroke: ${color || '#2B7CD3'};
            stroke-miterlimit: 10;
            margin: 10% auto;
            animation: scaleIn 0.3s ease-in-out;
          }
          .checkmark__circle {
            stroke-dasharray: 166;
            stroke-dashoffset: 166;
            stroke-width: 5;
            stroke-miterlimit: 10;
            fill: none;
            animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
          }
          .checkmark__check {
            stroke-dasharray: 48;
            stroke-dashoffset: 48;
            animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.4s forwards;
          }
          @keyframes stroke {
            100% { stroke-dashoffset: 0; }
          }
        `}
      </style>
      
      {!isExiting ? (
        <>
          <div style={styles.spinner} />
          <div style={styles.text}>{text || 'Preparing Your Big Jump...'}</div>
        </>
      ) : (
        <div style={styles.successAnimation}>
          <svg className="checkmark" viewBox="0 0 52 52">
            <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
            <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
          </svg>
        </div>
      )}
    </div>
  );
};

export default BJSpinner;